import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MainContext } from '@blaze-cms/nextjs-components';
import { useStringTemplate } from '@blaze-cms/utils-handlebars';
import Image from './Image';
import { useGetImageIdFromRelation, useGetImages, useGetSingleEntitySchema } from '../../hooks';
import { getImageIds, isUsingRelationImage as checkIfUsingRelationImage } from '../../helpers';
const ImageFactory = props => {
  const {
    imageId,
    parent: {
      itemId
    },
    parent,
    entity,
    fetchFromRelation,
    imageRelation,
    imgSrc
  } = props;
  const {
    isPreview
  } = useContext(MainContext);
  const {
    data: [imgSrcToUse]
  } = useStringTemplate(parent, [imgSrc]);
  const skipSingleEntitySchema = !entity || !!imgSrcToUse;
  const isUsingRelationImage = checkIfUsingRelationImage(entity, fetchFromRelation, imageRelation);
  const {
    data: {
      getEntitySchema: {
        actions = {}
      } = {}
    } = {}
  } = useGetSingleEntitySchema(entity, skipSingleEntitySchema);
  const {
    data: relationData,
    loading: relationLoading
  } = useGetImageIdFromRelation(itemId, imageRelation, actions, isUsingRelationImage, isPreview, !!imgSrcToUse);
  const updatedImageIds = relationLoading ? null : getImageIds(imageRelation, relationData, imageId);
  const imageIds = updatedImageIds && updatedImageIds.length === 1 ? updatedImageIds[0] : updatedImageIds;
  const {
    data: {
      getFile,
      getFiles = []
    } = {},
    loading,
    error
  } = useGetImages(imageIds, updatedImageIds && updatedImageIds.length > 1, !!imgSrcToUse);
  if (error) return error.message;
  if (loading) return '';
  if (imgSrcToUse) return /*#__PURE__*/React.createElement(Image, _extends({}, props, {
    imageUrl: imgSrcToUse,
    shouldRenderImgTag: true
  }));
  const files = getFile ? [getFile] : getFiles;
  return files.map(({
    id,
    data: imageData = {},
    url: imageUrl = ''
  }) => {
    if (!imageUrl) return null;
    return /*#__PURE__*/React.createElement(Image, _extends({
      key: id
    }, props, {
      imageData: imageData,
      imageUrl: imageUrl
    }));
  });
};
ImageFactory.propTypes = {
  entity: PropTypes.string,
  fetchFromRelation: PropTypes.bool,
  imageId: PropTypes.string,
  imageRelation: PropTypes.array,
  parent: PropTypes.object
};
ImageFactory.defaultProps = {
  entity: '',
  fetchFromRelation: false,
  imageId: '',
  imageRelation: [],
  parent: {}
};
export default ImageFactory;
//# sourceMappingURL=ImageFactory.js.map